const translations = {
	question: "Une question ?",
	contact: "Contacter Wenimmo",
};

export default translations;
